import { useSelector } from "react-redux";
import PanelLayout from "../../../layouts/PanelLayout";
import React from "react";
import { Container, Card, Row, Col, Alert } from "react-bootstrap";

function InicioData() {
  const usuario = useSelector((state) => state.usuario);
  const alumno = useSelector((state) => state.alumno);
  const ctacte = useSelector((state) => state.ctacte);

  const obtenerNivelAlumno = (al) =>
    al?.nivel ||
    al?.nivelNombre ||
    al?.nivelDescripcion ||
    al?.nombrenivel ||
    al?.descripcionNivel ||
    "";

  const obtenerCursoAlumno = (al) =>
    al?.curso ||
    al?.cursoNombre ||
    al?.cursoDescripcion ||
    al?.nombreCurso ||
    al?.grado ||
    al?.sala ||
    "";

  const obtenerCuotaAlumno = (al) =>
    Number(
      al?.importefinal ??
        al?.importeFinal ??
        al?.cuotaMensual ??
        al?.cuota ??
        al?.importeCuota ??
        al?.importe ??
        0
    );

  const alumnosDetalle =
    alumno
      ?.map((al, idx) => {
        const nombre =
          al?.nombre?.trim() ||
          al?.nombreAlumno?.trim() ||
          al?.alumno?.trim() ||
          `Alumno ${idx + 1}`;
        const nivel = obtenerNivelAlumno(al)?.trim();
        const curso = obtenerCursoAlumno(al)?.trim();
        const cuotaMensual = obtenerCuotaAlumno(al);

        return {
          id: al?.idalumno || al?.idAlumno || al?.id || idx,
          nombre,
          nivel,
          curso,
          cuotaMensual,
        };
      })
      .filter((al) => al.nombre) || [];

  const totalMensualApi = Number(
    usuario?.totalMensualActual ??
      usuario?.totalmensualactual ??
      usuario?.totalMensual ??
      usuario?.totalmensual ??
      usuario?.familia?.totalMensualActual ??
      usuario?.familia?.totalmensualactual ??
      usuario?.familia?.totalMensual ??
      usuario?.familia?.totalmensual
  );

  const totalMensualCalculado = alumnosDetalle.reduce(
    (s, al) => s + Number(al.cuotaMensual || 0),
    0
  );

  const totalMensualActual = Number.isFinite(totalMensualApi)
    ? totalMensualApi
    : totalMensualCalculado;

  const hoy = new Date();
  const mesActual = hoy.getMonth() + 1;
  const anioActual = hoy.getFullYear();

  const formatMoney = (n) =>
    new Intl.NumberFormat("es-AR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(
      Number(n || 0)
    );

  const calcularMesesDeMora = (mes, anio) => {
    const diferencia =
      (anioActual - Number(anio)) * 12 + (mesActual - Number(mes));
    return Math.max(0, diferencia);
  };

  const calcularTotalConInteresAcumulativo = (item) => {
    const base = Number(item.debe || 0) + Number(item.interes || 0);
    return base;
  };

  const cuotas = ctacte?.filter(
    (item) => item.codcomprobante === "C" || item.codcomprobante === "M"
  ) || [];
  const cuotasImpagas = cuotas.filter((cuota) => {
    const cuotaMes = Number(cuota.mes);
    const cuotaAnio = Number(cuota.anio);
    const total = Number(cuota.debe || 0) + Number(cuota.interes || 0);

    const esMesSiguiente =
      (cuotaAnio === anioActual && cuotaMes === mesActual + 1) ||
      (mesActual === 12 && cuotaAnio === anioActual + 1 && cuotaMes === 1);

    if (cuotaMes === 0 || total === 0 || esMesSiguiente) return false;
    if (cuotaAnio < 2025) return false;

    const estaPagada = ctacte.some(
      (mov) =>
        (mov.codcomprobante === "FC" || mov.codcomprobante === "FE") &&
        Number(mov.idInternoComprobantePagado) ===
          Number(cuota.idInternoComprobante)
    );

    const vencida =
      cuotaAnio < anioActual ||
      (cuotaAnio === anioActual && cuotaMes <= mesActual);

    return !estaPagada && vencida;
  });

  const resumenPorMes = {};
  cuotasImpagas.forEach((it) => {
    const key = `${Number(it.mes)}/${Number(it.anio)}`;
    const montoConInteres = calcularTotalConInteresAcumulativo(it);

    if (!resumenPorMes[key]) {
      resumenPorMes[key] = { total: 0, movimientos: [] };
    }

    resumenPorMes[key].total += montoConInteres;
    resumenPorMes[key].movimientos.push(it);
  });

  const cuotasAgrupadas = Object.entries(resumenPorMes)
    .map(([mesAnio, { total, movimientos }]) => {
      const [mes, anio] = mesAnio.split("/").map(Number);
      return { mes, anio, total, movimientos };
    })
    .sort((a, b) => a.anio - b.anio || a.mes - b.mes);

  const saldoPendienteTotal = cuotasAgrupadas.reduce(
    (sum, it) => sum + Number(it.total || 0),
    0
  );

  return (
    <PanelLayout>
      <Container className="py-3 py-md-4">
        <div className="inicio-portal-header mb-4">
          <div>
            <p className="inicio-portal-kicker mb-2">Portal de Familias</p>
            <h1 className="inicio-portal-title mb-1">Estado de cuenta</h1>
            <p className="inicio-portal-subtitle mb-0">
              Resumen actualizado de cuotas y matrículas pendientes por mes.
            </p>
          </div>
        </div>

        <Card className="border-0 shadow-sm inicio-portal-card">
          <Card.Body className="p-3 p-md-4 p-lg-5">
            <Row className="g-3 mb-4">
              <Col lg={4} md={6}>
                <div className="inicio-portal-info-box h-100">
                  <span className="inicio-portal-label">Familia</span>
                  <strong>{usuario?.familia?.apellido || "-"}</strong>
                </div>
              </Col>
            </Row>

            <section className="inicio-alumnos-section mb-4">
              <div className="inicio-alumnos-heading">
                <span className="inicio-portal-label mb-0">Alumnos</span>
              </div>

              {alumnosDetalle.length > 0 ? (
                <div className="inicio-alumnos-grid">
                  {alumnosDetalle.map((al) => (
                    <article key={al.id} className="inicio-alumno-card">
                      <div className="inicio-alumno-main">
                        <strong>{al.nombre}</strong>
                        <span>
                          {[al.nivel, al.curso].filter(Boolean).join(" - ") ||
                            "Nivel/curso no informado"}
                        </span>
                      </div>
                      <div className="inicio-alumno-cuota">
                        <span>Cuota mensual</span>
                        <strong>${formatMoney(al.cuotaMensual)}</strong>
                      </div>
                    </article>
                  ))}
                </div>
              ) : (
                <div className="inicio-alumnos-empty">
                  No hay alumnos cargados para esta familia.
                </div>
              )}

              <div className="inicio-alumnos-total">
                <span>Total mensual actual</span>
                <strong>${formatMoney(totalMensualActual)}</strong>
              </div>
            </section>

            {cuotasAgrupadas.length === 0 ? (
              <Alert variant="success" className="mb-0">
                No registra deuda pendiente.
              </Alert>
            ) : (
              <div className="inicio-deuda-panel">
                <div className="inicio-deuda-total">
                  <span>Total adeudado</span>
                  <strong>${formatMoney(saldoPendienteTotal)}</strong>
                </div>

                <div className="inicio-deuda-lista">
                  {cuotasAgrupadas.map((it, idx) => (
                    <div key={idx}>
                      <div className="inicio-deuda-item">
                        <div>
                          <span className="inicio-deuda-mes">
                            {new Date(it.anio, it.mes - 1).toLocaleString("es-AR", {
                              month: "long",
                              year: "numeric",
                            })}
                          </span>
                          <small className="inicio-deuda-caption">
                            Total adeudado del período
                          </small>
                        </div>
                        <strong>${formatMoney(it.total)}</strong>
                      </div>
                      {it.movimientos.map((mov, movIdx) => (
                        <div key={mov.idctacte ?? movIdx} className="d-flex justify-content-between gap-3 px-3 py-2">
                          <span>
                            {mov.codcomprobante === "M" ? "Matrícula" : "Cuota"}
                            {mov.detalle || mov.observacion ? ` - ${mov.detalle || mov.observacion}` : ""}
                          </span>
                          <strong className="text-nowrap">
                            ${formatMoney(calcularTotalConInteresAcumulativo(mov))}
                          </strong>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
    </PanelLayout>
  );
}

export default InicioData;
